/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useTranslation } from 'react-i18next';
import { TableCell } from '@material-ui/core';
import React from 'react';
import classNames from 'classnames';
import useStyles from '../FOTableHeadStyle';

const FOHeadCombinedCell = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data, screenSize } = props;

  if (data?.showOnNonXLDevice || screenSize.isExtraLargeOrBigger) {
    return (
      <TableCell className={classNames(classes.tableHeadCell, classes[props.className])}>
        <div className={classes.combinedColumn}>
          {data.label?.map((label, index) => {
            return <span key={index}>{t(label)}</span>;
          })}
        </div>
      </TableCell>
    );
  }
  return null;
};

FOHeadCombinedCell.defaultProps = {
  data: {
    className: '',
    label: [],
  },
};

function propsAreEqual(prevProps, nextProps) {
  return (
    prevProps?.className === nextProps?.className &&
    prevProps.label?.length === nextProps.label?.length &&
    prevProps.screenSize?.isExtraLargeOrBigger === nextProps.screenSize?.isExtraLargeOrBigger
  );
}

const MemoizedFOHeadCombinedCell = React.memo(FOHeadCombinedCell, propsAreEqual);

export default MemoizedFOHeadCombinedCell;
